<template>
  <role-index title="Roles de AV Flow" av-flow :admin="false" />
</template>

<script>
import RoleIndex from '../RoleIndex'
export default {
  components: { RoleIndex }
}
</script>

<style></style>
